import { Suspense } from 'react';

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import * as m from '@/paraglide/messages.js';

import { JobsList } from './-components/JobsList';

const internshipsSearchSchema = z.object({
  page: z.number().catch(1).default(1),
});

export const Route = createFileRoute('/{-$locale}/internships')({
  validateSearch: internshipsSearchSchema,
  component: InternshipsPage,
  errorComponent: ErrorComponent,
});

function InternshipsPage() {
  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Suspense fallback={<LoadingSpinner message={m.loading_offers()} />}>
        <JobsList />
      </Suspense>
    </div>
  );
}
